export class Credenciales {
    public username?: string;
    public password?: string;

    constructor(
        login?: string,
        password?: string
    ) {
        this.username = login ? login : null;
        this.password = password ? password : null;
    }
}
